import React, { Component } from "react";
import AUX from "../../hoc/Aux_";
import MUIDataTable from "mui-datatables";
import Button from "@material-ui/core/Button";
import { toast, ToastContainer } from "react-toastify";
import { pushSelectedCategory } from "../../actions/general";
import { prediketList, uploadRdf } from "../../api/kugi";
import { connect } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

class TableUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      fcid: 1,
      action: "add",
      code: "",
      loader: true,
      predikat: [],
      choosenData: {},
      loading: false,
    };
  }

  componentWillMount() {
    if (localStorage.getItem("token") == null) {
      console.log(localStorage.getItem("token"));
      this.props.history.push(`/login`);
    }

    prediketList()
      .then(async (res) => {
        this.setState({ predikat: res.data, loader: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loader: false });
      });
  }

  handleReload = () => {
    prediketList()
      .then(async (res) => {
        this.setState({ predikat: res.data, loader: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loader: false });
      });
  };

  handleFile = (e, data) => {
    this.props.loadingTrue();
    if (data[1]) {
      uploadRdf(e.target.files[0], this.handlePredikat(data[2]), "")
        .then(() => {
          this.props.loadingFalse();
          toast.success("Successfuly upload file", {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .catch((err) => {
          console.log(err.response.data.message);
          this.props.loadingFalse();
          toast.error("Error uploading file", {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    } else {
      uploadRdf(e.target.files[0], this.handlePredikat(data[2]), "")
        .then(() => {
          this.props.loadingFalse();
          this.props.handleSuccess(true)
        })
        .catch((err) => {
          console.log(err.response.data.message);
          this.props.loadingFalse();
          this.props.handleSuccess(false)
        });
    }
  };

  handlePredikat = (e) => {
    if (e !== "ONTOLOGI") {
      const temp = e.split("#");
      return temp[1];
    } else {
      return e;
    }
  };

  render() {
    const options = {
      filter: false,
      selectableRows: false,
      rowsPerPage: 5,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.state.loader
            ? "Searching..."
            : "Sorry, no matching records found",
        },
      },
    };

    const columns = [
      { name: "labelprediket", label: "Predikat" },
      { name: "namaFile", label: "File" },
      {
        name: "namaprediket",
        label: "action",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                {/* <Button
                  variant="outlined"
                  color="primary"
                  onClick={() =>
                    this.setState({
                      open: true,
                      choosenData: { name: tableMeta.rowData },
                    })
                  }
                > */}
                <form>
                  <input
                    multiple
                    type="file"
                    id="filePrediket"
                    name="filePrediket"
                    onChange={(e) => this.handleFile(e, tableMeta.rowData)}
                    style={{ display: "none" }}
                  />
                  <label
                    htmlFor="filePrediket"
                    style={{
                      backgroundColor: "#497ac2",
                      color: "#FFF",
                      padding: "10px",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                  >
                    Upload
                  </label>
                </form>
              </div>
            );
          },
        },
      },
    ];

    return (
      <AUX>
        <section
          className="sections"
          style={{ paddingTop: "5%", marginBottom: 30 }}
        >
          <center>
            <h3>Data RDF</h3>
          </center>
          <div className="row justify-content-center" />
          <div className="container">
            <MUIDataTable
              data={this.state.predikat}
              columns={columns}
              options={options}
            />
            <div className="container">
              <div className="row justify-content-center" id="counter" />
            </div>
          </div>
          <ToastContainer
            position="bottom-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Dialog
            open={this.state.open}
            onClose={() => this.setState({ open: false })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">Upload RDF</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Apakah anda yakin ingin mengubah file dengan predikat{" "}
                {this.state.choosenData.name}?
              </DialogContentText>
              <DialogActions>
                <Button
                  variant="contained"
                  style={{
                    outline: "none",
                  }}
                  onClick={() => this.setState({ open: false })}
                >
                  Tidak
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
        </section>
      </AUX>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    categorySelected: state.categorySelected,
  };
};

export default connect(
  mapStatetoProps,
  { pushSelectedCategory }
)(TableUpload);
